import { useEffect, useState } from 'react';

/**
 * Estado del filtro de período (MonthRangePicker) que sobrevive a recargar la página (F5).
 * Se guarda en sessionStorage: vale para esa pestaña del navegador; una pestaña nueva
 * arranca con el valor inicial (normalmente el mes actual).
 *
 * @param {string} clave  nombre único de la pantalla (p. ej. 'fec')
 * @param {object|function} inicial  valor por defecto, o función que lo calcula
 */
export default function useFiltroPeriodo(clave, inicial) {
  const llave = `filtroPeriodo:${clave}`;
  const [valor, setValor] = useState(() => {
    try {
      const guardado = sessionStorage.getItem(llave);
      if (guardado) return JSON.parse(guardado);
    } catch { /* almacenamiento no disponible o dato dañado: se usa el inicial */ }
    return typeof inicial === 'function' ? inicial() : inicial;
  });
  useEffect(() => {
    try {
      if (valor == null) sessionStorage.removeItem(llave);
      else sessionStorage.setItem(llave, JSON.stringify(valor));
    } catch { /* sin almacenamiento: solo se pierde al recargar */ }
  }, [llave, valor]);
  return [valor, setValor];
}
